export default {"src":"/_next/static/media/HarvesterIcon.b248feac.svg","height":75,"width":111};